import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=1063bf19"
import script from "./Timeline.vue?vue&type=script&lang=ts"
export * from "./Timeline.vue?vue&type=script&lang=ts"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=1063bf19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports